import { useQuery } from "react-query";

import { adminApis, queryKeys } from "./index";

export const useGetDataPot = () => {
  return useQuery([queryKeys.JACKPOT_DATA], adminApis.getJackpotData, {
    keepPreviousData: true,
  });
};
